import logo1 from '../../ressources/logos/waldmonitor_A.png'
import logo2 from '../../ressources/logos/waldmonitor_arnsberg_bigA.png'

import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useTheme } from '@mui/material/styles';
import Logo from '../logos/Logo';
import config from '../../config.json'

export default function NavigationDesktop(props) {
    const theme = useTheme();
    const drawerWidth = config.sizing.drawerWidthDesktop;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor:theme.palette.navBackground.main,

                    },
                }}
                variant="permanent"
                anchor="left"
            >
                <Toolbar sx={{backgroundColor: "white"}}>
                    {/* <Box
                        component="img"
                        sx={{
                            m: 1,
                            p:1,
                            width: 240
                        }}
                        src={logo2}
                    /> */}
                    <Box sx={{
                            // m: 1,
                            p:1
                        }}>
                    <Logo width='240px' imageSource={logo2} urlClick="https://www.arnsberg.de/smart-city/das-modellprojekt/projektportfolio" />


                    </Box>
                </Toolbar>
                <Divider />
                {props.children}
            </Drawer>

        </Box>
    );
}